function isStringArrayArray(maybeStringArrayArray) {
  return Array.isArray(maybeStringArrayArray) && maybeStringArrayArray.every(maybeStringArray => Array.isArray(maybeStringArray) && maybeStringArray.every(maybeString => typeof maybeString === 'string'));
}
export const parseRoutingTeamsValue = value => {
  let parsedValue;
  let parseError = false;
  try {
    const jsonValue = value.length ? JSON.parse(value) : undefined;
    if (typeof jsonValue === 'undefined' || isStringArrayArray(jsonValue)) {
      parsedValue = jsonValue && jsonValue.filter(stringArray => stringArray.length);
    } else {
      throw new Error('Invalid value shape.');
    }
  } catch (_unused) {
    parseError = true;
  }
  return {
    parsedValue,
    parseError
  };
};
export const parseWhatsAppTemplateValue = value => {
  let parsedValue;
  let parseError = false;
  try {
    parsedValue = value.length ? JSON.parse(value) : undefined;
  } catch (_unused2) {
    parseError = true;
  }
  return {
    parsedValue,
    parseError
  };
};